import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { ROUTE_PATHS } from '../components/_pages/_utils/router.utils';
import { captureDeepLinkEvent } from '../analytics/sentry';

const AppUrlListener: React.FC<any> = () => {
  const navigate = useNavigate();

  useEffect(() => {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      if (event.url.includes('firebaseauth')) return;

      const url = new URL(event.url);
      const slug = url.pathname;

      // For magic links, preserve the token and path query params
      const search = url.search;

      const isKnownRoute = !!slug && Object.values(ROUTE_PATHS).includes(slug);

      if (isKnownRoute) {
        captureDeepLinkEvent('matched_route', { url: event.url, slug, search });
        navigate(slug + search);
      } else {
        // Unrecognized path — falls through to '/', which for an authenticated/onboarded user
        // immediately redirects to /dashboard (see home.layout.tsx), tearing down whatever
        // screen was on-screen. Logged so an unexpected mid-flow bounce can be traced back here.
        captureDeepLinkEvent('unmatched_route_fallback_home', { url: event.url, slug, search });
        navigate('/');
      }
    });
  }, []);

  return null;
};

export default AppUrlListener;
